import { render, staticRenderFns } from "./organization-control-view.vue?vue&type=template&id=bb8eaf00&scoped=true&"
import script from "./organization-control-view.vue?vue&type=script&lang=js&"
export * from "./organization-control-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-control-view.vue?vue&type=style&index=0&id=bb8eaf00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8eaf00",
  null
  
)

export default component.exports